import { jwtDecode } from "jwt-decode";

let accessToken = null;
let currentUser = null;

export const setAccessToken = (token) => {
  accessToken = token;
  try {
    const decoded = jwtDecode(token);
    currentUser = decoded || null;
  } catch {
    currentUser = null;
  }
};

export const getAccessToken = () => accessToken;

export const getCurrentUser = () => currentUser;

export const clearAccessToken = () => {
  accessToken = null;
  currentUser = null;
};